<template>
  <Header>
    <b-navbar class="px-10" toggleable="lg" id="design-header">
      <div style="height: 35px" class="pr-10">
        <img
          style="height: 100%"
          :src="
            require(`@assets/images/logo/logo-${logoColor}/logo_mwe_minimal.png`)
          "
          v-b-tooltip.hover
          :title="builddetail"
        />
      </div>
      <b-button size="md" variant="default" :href="services.webbuilderCmsUrl+'?option=com_dashboard&option_redirect=1'" class="fs-db-20 fw-400">
        {{ $t("engine.topbar.btnManage", languageEngine) }}
      </b-button>

      <VerticalLine class="mx-10"></VerticalLine>

      <PageSelect></PageSelect>

      <VerticalLine class="ml-10 mr-15"></VerticalLine>
      <b-dropdown
        toggle-class="text-decoration-none"
        no-caret
        variant="unset flag-dropdown p-10"
        v-b-tooltip.hover
        :title='$t("engine.topbar.language.lblTitle", languageEngine)'
        class="item-languages"
      >
        <template #button-content>
          <i
            :class="`flag-icon flag-icon-${
              languages &&
              languages[languageUse] &&
              languages[languageUse].flagIcon
            }`"
          ></i>
          {{ languageUse && languageUse.toUpperCase() }}
          <i class="fal fa-chevron-down"></i>
        </template>
        <b-dropdown-item
          href="#"
          v-for="(item, lang, lang_index) in languages"
          :key="`Lang${lang_index}`"
          @click="switchLanguageUse(lang)"
        >
          <i :class="`flag-icon flag-icon-${item.flagIcon}`"></i>

          {{ item.language.toUpperCase() }}
        </b-dropdown-item>
      </b-dropdown>

      <VerticalLine class="mx-10" v-if="isShowSeo"></VerticalLine>
      <div class="text-primary align-self-center seo" @click="openModalSeo" v-if="isShowSeo">
        <span class="icon-custom"> <i class="fas fa-cog"></i> </span>
        <span class="fs-db-20 fw-400"> 
          {{ $t("engine.topbar.btnSEO", languageEngine) }}
        </span>
      </div>

      <VerticalLine class="mx-10" v-if="domain"></VerticalLine>
      <div class="text-primary text-nowrap align-self-center" v-if="domain">
        <a class="fs-db-20 fw-400" :href="domain" target="_blank">{{ domainDisplay }}</a>
      </div>

      <!-- <b-button class="text-muted" variant="unset" @click="showTutorial">
        <i class="fas fa-book"></i>
      </b-button> -->
      <div class="devices-select">
        <div class="d-flex justify-content-center">
          <ScreenDevice
            :class="{ active: screenSize === 'Desktop' }"
            @click="setIframeDevice('Desktop')"
            class="text-center d-flex align-items-center justify-content-center"
          >
            <i class="fal fa-desktop"></i>
          </ScreenDevice>
          <ScreenDevice
            :class="{ active: screenSize === 'Tablet' }"
            @click="setIframeDevice('Tablet')"
            class="text-center d-flex align-items-center justify-content-center"
          >
            <i class="fal fa-tablet"></i>
          </ScreenDevice>
          <ScreenDevice
            :class="{ active: screenSize === 'Mobile' }"
            @click="setIframeDevice('Mobile')"
            class="text-center d-flex align-items-center justify-content-center"
          >
            <i class="fal fa-mobile"></i>
          </ScreenDevice>
        </div>
        
      </div>

      <!-- <b-navbar-nav class="mr-gd-2"> -->
        <!-- <div class="d-flex align-items-center"> -->
          <b-button
            id="undo-btn"
            class="mx-1 btn-data"
            variant="unset"
            v-b-tooltip.hover.bottom="canUndo ? $t('engine.topbar.undo', languageEngine) : ''"
            :disabled="!canUndo"
            @click="$store.dispatch('design/snapshot/undo')"
          >
            <b-icon icon="arrow90deg-left" aria-hidden="true"></b-icon>
          </b-button>
          <b-button
            id="redo-btn"
            class="btn-data"
            variant="unset"
            v-b-tooltip.hover.bottom="canRedo ? $t('engine.topbar.redo', languageEngine) : ''"
            :disabled="!canRedo"
            @click="$store.dispatch('design/snapshot/redo')"
          >
            <b-icon icon="arrow90deg-right" aria-hidden="true"></b-icon>
          </b-button>
          <AutosaveContainer
            class="text-center pr-gd-1 text-status saveBtn"
            style="max-width:120px;display: flex;justify-content: center;"
          >
            <div class="w-100 text-muted" v-show="autoSaving">
              <span class="icon-custom"> <i class="far fa-sync-alt fa-spin"></i> </span>
              <span class="fs-db-20 fw-400"> {{ $t("engine.topbar.btnSaving", languageEngine) }} </span> 
            </div>
            <div class="text-danger w-100" v-show="!autoSaving && synceError"> 
              <span class="fs-db-20 fw-400"> {{ $t("engine.topbar.btnSaveFail", languageEngine) }} </span> 
            </div>
            <div class="text-success w-100" v-show="!autoSaving && isShowSaved"> 
              <span class="icon-custom"> <i class="fas fa-check"></i> </span>
              <span class="fs-db-20 fw-400">  {{ $t("engine.topbar.btnSaved", languageEngine) }}  </span> 
            </div>
            <div class="text-primary cursor-pointer save" :class="{'disabled' : !autoSaving}" @click="save(true)" v-show="!autoSaving && !isShowSaved && !synceError"> 
              <span class="icon-custom"> <i class="fas fa-save"></i> </span>
              <span class="fs-db-20 fw-400"> {{ $t("engine.topbar.btnSave", languageEngine) }}  </span> 
            </div>
          </AutosaveContainer>
        <!-- </div> -->
        <!-- <b-button class="mr-gd-2 text-danger" pill variant="danger" id="seobutton" @click="openModalSeo"> 
          <i class="fas fa-exclamation-circle"></i>
          SEO 
        </b-button> -->
        <div class="btn-manage">
          <a @click="goPreview">
            <b-button size="md" variant="default" class="fs-db-20 fw-400 text-nowrap" id="preview-btn" >
              {{ $t("engine.topbar.btnPreview", languageEngine) }}
            </b-button>
          </a>
          <a @click.stop.prevent="publishWebsite" >
            <b-button size="md" class="px-gd-2 ml-gd-1 fs-db-20 fw-400 text-nowrap"  variant="blue" :disabled="autoSaving">
              {{ $t("engine.topbar.btnPublish", languageEngine) }}
            </b-button>
          </a>
        </div>
        <b-overlay
          style="width: 100vw; height: 100vh"
          :show="publishing"
          no-wrap
        >
          <template #overlay>
            <div class="text-center">
              <b-icon
                class="mb-3"
                icon="stopwatch"
                font-scale="3"
                animation="cylon"
              ></b-icon>
              <b-progress
                :value="publishPercent"
                variant="success"
                striped
                :animated="true"
              ></b-progress>
              <p>Your website is Publishing Please wait...</p>
            </div>
          </template>
        </b-overlay>
      <!-- </b-navbar-nav> -->
    </b-navbar>
    <Tutorial
      :ref="`tutorial`"
      :data="[
        { url: '/page/home' },
        {
          selector: '#btn-select-page',
          direction: 'bottom',
          card: { title: 'Manage Page' },
        },
        {
          selector: '#add-section-btn',
          card: { title: 'Add section button' },
        },
        {
          selector: '#header-section',
          card: { title: 'Header section' },
        },
        {
          url: '/page/home/content/header',
        },
        {
          selector: '#header-layout',
          card: { title: 'Header layout' },
        },
        {
          url: '/page/home/content/header/layout',
        },
        {
          selector: '#header-layout-desktop',
          card: { title: 'Header layout desktop' },
        },
        {
          selector: '#header-layout-desktop-template',
          card: { title: 'Header layout desktop template' },
        },

        { url: '/page/home' },
        {
          selector: '#website_theme',
          direction: 'top',
          card: { title: 'Website Theme' },
        },
        { url: '/page/home/content/website_theme' },
        {
          selector: '.hilight',
          card: { title: 'Color Picker' },
        },
        {
          selector: '.pl-5.align-self-end',
          card: { title: 'Color Shading' },
        },
        { url: '/page/home' },
      ]"
    />
    <SEO v-if="sitePageID" :id="sitePageID" />
  </Header>
</template>

<script>
import { DateTime } from "luxon";
import styled from "vue-styled-components";
import { mapGetters } from "vuex";
import Tutorial from "@components_system/Tutorial/Tutorial";
import PageSelect from "./PageSelect/PageSelect";
import SEO from "@components_system/Design/Modal/SEO/SEO";

const Header = styled.div`
  .navbar {
    height: 56px;
    background-color: #fff;
    padding: 0;
    /* z-index: 10000; */
    z-index: 1036;
    background: #ffffff;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
    border-bottom: 1px solid var(--line);
  }
  @media only screen and (max-width: 1139px)   {
    .navbar {
      height: 112px;
      flex-wrap:wrap;
    }
  }
  @media only screen and (max-width: 1000px)   {
    .navbar {
      justify-content: start !important;
    }
  }
  .select-page {
    min-width: 180px;
  }
  .page-title {
    color: #24BEE2;
  }
`;
const VerticalLine = styled.div`
  width: 1px;
  height: 26px;
  background-color: var(--line);
`;
const ScreenDevice = styled.div`
  height: 56px;
  width: 40px;
  font-size: 20px;
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #CDD3DA;
  &::after {
    transition: all 0.1s ease;
    content: "";
    position: absolute;
    width: 100%;
    height: 0px;
    background-color: #24BEE2;
    bottom: 0;
  }

  &.active,
  &:hover {
    color: #24BEE2;
    &::after {
      height: 3px;
    }
  }
`;
const AutosaveContainer = styled.div`
  /* position: absolute; */
  /* margin-left: 16px; */
  bottom: 0;
  top: 0;
  width: max-content;
`;

// const getLocalStorge = () => {
//   let snapshotSynce = localStorage.getItem('snapshotData') || [];
//   if(snapshotSynce.length) {
//     snapshotSynce = JSON.parse(snapshotSynce);
//   }
//   return snapshotSynce;
// }

export default {
  data() {
    return {
      tutorial: false,
      langs: ["th", "en"],
      logoColor: process.env.VUE_APP_WEB_ICON_COLOR,
      isShowSaved : false,
    };
  },
  components: {
    Header,
    Tutorial,
    VerticalLine,
    AutosaveContainer,
    ScreenDevice,
    PageSelect,
    SEO,
  },
  methods: {
    setIframeDevice(size) {
      this.$store.dispatch("design/setScreenSize", { size: size });
      this.$store.dispatch("designIframe/setScreenSize", { size: size });
      this.$store.dispatch("designIframe/frame/setRenderTools", { renderTools: (size == 'Tablet') ? false : true });
    },
    async publishWebsite() {
      await this.save();
      this.$store.dispatch("design/page/publishWebsite");
    },
    async switchLanguageUse(lang) {
      await this.save();
      this.$store.dispatch("design/site/setLanguageUse", {
        language: lang,
      });
      this.$store.dispatch("designIframe/page/initLanguage", {
        language: lang,
      });
      this.$store.dispatch("designIframe/page/getSiteMetadata", {
        lang: lang,
      });
      this.$store.dispatch("designIframe/page/getPage", {
        metaDataID: "",
        lang: lang,
      });
    },
    showTutorial() {
      this.$refs.tutorial.init();
    },
    async goPreview() {
      await this.save();
      const arr = location.hash.replace("#/", "").replace("#", "").split("/");
      const metaDataID = arr[0] == "page" ? arr[1] : undefined;
      if (metaDataID) {
        this.$router.push("/preview#/page/" + metaDataID);
      } else {
        this.$router.push("/preview");
      }
    },
    openModalSeo() {
      this.$bvModal.show('modal-seo-setting');
    },
    async save(manualSave = false) {
      if(!manualSave) {
        this.$store.dispatch('design/snapshot/clearSnapshotInterval');
      }
      await this.$store.dispatch('design/snapshot/synceSnapshot',{ manualSave }).then(() => {
        return true;
      });
    }
  },
  computed: {
    ...mapGetters({
      domains: "design/site/domains",
      languages: "design/site/languages",
      languageUse: "design/site/languageUse",
      languageEngine: "design/userPreference/languageEngine",
      screenSize: "screenSize",
      canUndo: "design/snapshot/canUndo",
      canRedo: "design/snapshot/canRedo",
      logs: "design/snapshot/logs",
      logsIndex: "design/snapshot/logsIndex",
      elHoverID: "design/component/elHoverID",
      elActiveID: "design/component/elActiveID",
      autoSaveTimeStamp: "design/snapshot/autoSaveTimeStamp",
      autoSaving: "design/snapshot/autoSaving",
      publishStatus: "design/page/publishStatus",
      synceResponse: "design/snapshot/synceResponse",
      synceError: "design/snapshot/synceError",
      synceDiff: "design/snapshot/synceDiff",
      snapshotSynce: "design/snapshot/snapshotSynce",
      services: "design/site/services",
      siteComponents: "design/metadata/siteComponents",
      sitePageID: "design/metadata/sitePageID",
    }),
    domain() {
      return this.domains.main && `https://${this.domains.main}`;
    },
    domainDisplay() {
      return this.domains.main;
    },
    savedTime() {
      return this.autoSaveTimeStamp.toLocaleString(
        DateTime.TIME_24_WITH_SECONDS
      );
    },
    publishPercent() {
      const { done, total } = this.publishStatus.task;
      return (done / total) * 100;
    },
    publishing() {
      return this.publishStatus.status !== "published";
    },
    builddetail() {
      const dt = DateTime.fromISO(process.env.VUE_APP_BUILDDATE);
      return dt.toLocaleString(DateTime.DATETIME_MED_WITH_SECONDS);
    },
    getNotSave() {
      let snapshot = [];
      this.snapshotSynce.filter(item => item.op !== 'test').forEach((item) => {
          const index = snapshot.findIndex(i => i.path === item.path)
          const is_added = snapshot.findIndex(i => i.path === item.path && i.op == 'add')
          if (index > -1 && item.path) {
            snapshot.splice(index, 1)
          }
          const immediatelyRemove = item.op == 'remove' && is_added > -1
          if (!immediatelyRemove) {
            snapshot.push({
              ...item, path: item.path
            });
          }
        })
      return snapshot;
    },
    isShowSeo() {
      return this.siteComponents[this.sitePageID] && this.siteComponents[this.sitePageID].properties.type !== 'content_item';
    }
  },
  watch: {
    autoSaving : {
      handler(next) {
        if(next) {
          this.isShowSaved = true;
          setTimeout(() => {
            this.isShowSaved = false;
          }, 5000);
        }
      }
    },
  }
};
</script>

<style lang="scss">
.item-languages {
  .dropdown-menu {
    min-width: unset;
  }
  .dropdown-menu.show {
    font-size: 14px;
    line-height: 25px;
    box-shadow: 0 6px 12px rgb(0 0 0 / 18%);
    border: unset;
  }
  .dropdown-item {
    padding: 0px 15px 0px 15px;
  }
}
/* #seobutton {
  background-color: #f9edee;
  border-color:#f9edee;
} */
.icon-custom {
  font-size: 14px;
}
.seo  {
  cursor: pointer;
  min-width: 45px;
  &:hover { 
    text-decoration: underline;
    color: #009dc1 !important;
  }
}
.save {
  &:hover {
    color: #009dc1 !important;
    text-decoration: underline;
  }
}
.btn-data {
  color : #373E44;
  &:disabled {
    color : #CDD3DA;
  }
}
.devices-select {
    width: calc(100% - 1038px);
}
.text-status {
  width: 100%;
}
.btn-manage {
  display: flex;
}
.saveBtn {
  min-width: fit-content;
}
@media only screen and (max-width: 1139px)   {
  .saveBtn {
    width: fit-content;
  }
  .devices-select {
    width: calc(100% - 964px);
  }
}
@media only screen and (max-width: 1060px)   {
  .devices-select {
    width: calc(100% - 925px);
  }
}
@media only screen and (max-width: 1030px)   {
  .devices-select {
    width: calc(100% - 855px);
  }
}
@media only screen and (max-width: 940px)   {
  .devices-select {
    width: calc(100% - 787px);
  }
}
@media only screen and (max-width: 885px)   {
  .devices-select {
    width: calc(100% - 750px);
  }
}
@media only screen and (max-width: 840px)   {
  .devices-select {
    width: calc(100% - 720px);
  }
}
@media only screen and (max-width: 840px)   {
  .devices-select {
    width: calc(100% - 645px);
  }
}
</style>